export default __webpack_public_path__ + "static/ministry-of-digital-transformation-08d2f8a7d3d1ceb4373fc936f69b047e.svg";